import * as Flowbite from 'flowbite-react';
import { BaseInputProps } from '../types';
import { theme } from './theme';

type FileInputProps = BaseInputProps<FileList | null> & {
    accept?: string;
    multiple?: boolean;
};

export const FileInput = ({
    value = null,
    onChange = () => {},
    label,
    accept,
    multiple = false,
    color = 'primary',
    ...props
}: FileInputProps) => (
    <Flowbite.Label className="flex flex-col gap-2 font-normal" color={color}>
        {label && <span className="font-medium">{label}</span>}
        <Flowbite.FileInput
            {...props}
            color={color}
            theme={theme}
            accept={accept}
            multiple={multiple}
            onChange={(e) => onChange(e.target.files)}
        />
    </Flowbite.Label>
);
FileInput.displayName = 'FileInput';
